import { IBuyBarProductVariant } from 'shared/types/BuyBarProductVariant';

export const getLowestPricedVariant = (itemList: IBuyBarProductVariant[]) => {
  // eslint-disable-next-line unicorn/no-array-reduce
  const lowestPriceVariant = itemList.reduce((prev, curr) => {
    const {
      lowestPriceCents: { amount: prevPrice },
    } = prev;
    const {
      lowestPriceCents: { amount: currPrice },
    } = curr;
    return prevPrice < currPrice ? prev : curr;
  });
  return lowestPriceVariant;
};
